module.exports = __webpack_public_path__ + "static/media/shequ-title-5.03f46b17.png";